import React from 'react'
import "./Decor.scss"

function Decor() {
  return (
    <div>Decor</div>
  )
}

export default Decor